import React, { Suspense, lazy } from 'react';
import { HeaderBar } from './components/HeaderBar';
import { HeroSection } from './components/HeroSection';
import { MetaPixel } from './components/MetaPixel';
// Lazy load components below the fold for faster initial render
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const EbookContents = lazy(() => import('./components/EbookContents').then(m => ({
  default: m.EbookContents
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const CouplesTestimonials = lazy(() => import('./components/CouplesTestimonials').then(m => ({
  default: m.CouplesTestimonials
})));
const AboutPaula = lazy(() => import('./components/AboutPaula').then(m => ({
  default: m.AboutPaula
})));
const OfferBonuses = lazy(() => import('./components/OfferBonuses').then(m => ({
  default: m.OfferBonuses
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const FloatingCTA = lazy(() => import('./components/FloatingCTA').then(m => ({
  default: m.FloatingCTA
})));
const SalesNotification = lazy(() => import('./components/SalesNotification').then(m => ({
  default: m.SalesNotification
})));
export function App() {
  return <div className="min-h-screen flex flex-col selection:bg-gold-main/30 selection:text-brown-dark" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <HeaderBar data-id="element-2" />
      <main className="flex-grow" data-id="element-3">
        <HeroSection data-id="element-4" />
        <Suspense fallback={<div className="h-32 bg-cream-light" data-id="element-6" />} data-id="element-5">
          <ProblemSection data-id="element-7" />
          <EbookContents data-id="element-8" />
          <Testimonials data-id="element-9" />
          <CouplesTestimonials data-id="element-10" />
          <AboutPaula data-id="element-11" />
          <OfferBonuses data-id="element-12" />
          <Guarantee data-id="element-13" />
          <FAQ data-id="element-14" />
          <FinalCTA data-id="element-15" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-16">
        <Footer data-id="element-17" />
        <FloatingCTA data-id="element-18" />
        <SalesNotification data-id="element-19" />
      </Suspense>
    </div>;
}